/**
 * URL e path canonici del sito pubblico (slash finale obbligatorio, tranne `/`).
 * Logica allineata a scripts/canonical-path.js (post-build).
 */
export function canonicalPath(path) {
  if (path == null || path === '' || path === '/') return '/';
  const p = path.startsWith('/') ? path : `/${path}`;
  const trimmed = p.replace(/\/+$/, '');
  if (trimmed === '') return '/';
  return `${trimmed}/`;
}

export function toCanonicalUrl(baseUrl, path) {
  const base = String(baseUrl || '').replace(/\/+$/, '');
  const cp = canonicalPath(path);
  if (cp === '/') return `${base}/`;
  return `${base}${cp}`;
}

/** Path per Link/navigate React (es. `/medici/`, `/blog/slug/`). */
export function publicPath(path) {
  return canonicalPath(path);
}
